// @core/api/endpoints/userprofile/update_userprofile.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  UpdateUserprofileRequest,
  UserprofileResponse,
} from '../../../types/userprofile';

const BASE_PATH = '/userprofile';

/**
 * Update user profile
 * Updates profile information including display name, bio, avatar, and other profile fields. Only the profile owner can update their profile.
 */
export async function UpdateUserprofile(
  profile_id: string,
  data: UpdateUserprofileRequest,
  options?: RequestOptions
): Promise<UserprofileResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:profile_id`;
  requestPath = requestPath.replace(':profile_id', encodeURIComponent(profile_id));
  const requestOptions = options;
  return client.put<UserprofileResponse>(requestPath, data, requestOptions);
}
